import { render } from "./ManageProduct.vue?vue&type=template&id=aac7469c&scoped=true"
import script from "./ManageProduct.vue?vue&type=script&lang=js"
export * from "./ManageProduct.vue?vue&type=script&lang=js"

import "./ManageProduct.vue?vue&type=style&index=0&id=aac7469c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac7469c"]])

export default __exports__